import { render } from "./FundRecord.vue?vue&type=template&id=59da50ea&scoped=true"
import script from "./FundRecord.vue?vue&type=script&lang=js"
export * from "./FundRecord.vue?vue&type=script&lang=js"

import "./FundRecord.vue?vue&type=style&index=0&id=59da50ea&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59da50ea"]])

export default __exports__